import type { JSX } from 'react'
import type { INoContentBlockProps } from '../NoContentBlock'

import { NoContentTextBlock } from 'blocks/TextBlock/Templates'
import { LAYOUT_BLOCK_PADDINGS } from 'vars/index'
import { NoContentBlockDirection } from '../NoContentBlock.h'
import { NoContentBlockDisplayNoneSC } from './NoContentBlockDisplayNone.styled'

export interface INoContentBlockDisplayNoneProps extends INoContentBlockProps {
  title: string
}

export const NoContentBlockDisplayNone = ({
  children,
  width = '100%',
  direction = NoContentBlockDirection.Column,
  flexGrow = 1,
  paddings = LAYOUT_BLOCK_PADDINGS.SIZE_40,
  title,
  ...rest
}: INoContentBlockDisplayNoneProps): JSX.Element => (
  <NoContentBlockDisplayNoneSC
    width={width}
    direction={direction}
    flexGrow={flexGrow}
    paddings={paddings}
    {...rest}
  >
    {children}
    <NoContentTextBlock title={title} />
  </NoContentBlockDisplayNoneSC>
)
